import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class LoraPacketRxInfo {

  @jsonMember({name: 'rssi'})
  public RSSI!: number;

  @jsonMember({name: 'loraSNR'})
  public LoraSNR!: number;

  @jsonMember({name: 'channel'})
  public Channel!: number;

  @jsonMember({name: 'rfChain'})
  public RFChain!: number;

}
